import angular from 'angular';

import { StrategiesService } from './strategies.services.js';
import { FacebookService } from './facebook.services.js';
import { TwitterService } from './twitter.services.js';
import { Instagram2Service } from './instagram2.services.js';
import { WebchatService } from './webchat.services.js';
import { GmbService } from './gmb.services.js';
import { GbmService } from './gbm.services.js';
import { WhatsappService } from "./whatsapp.services";
import { BusinessChatService } from "./business-chat.services";
import { TrustpilotService } from "./trustpilot.services";
import { LineService } from "./line.services";
import { KakaotalkService } from "./kakaotalk.services";
import { LinkedinService } from "./linkedin.services";
import { TiktokService } from "./tiktok.services";


angular
  .module('strategies', [])
  .factory('FacebookFactory', FacebookService.FacebookFactory)
  .factory('TwitterFactory', TwitterService.TwitterFactory)
  .factory('Instagram2Factory', Instagram2Service.Instagram2Factory)
  .factory('StrategiesFactory', StrategiesService.StrategiesFactory)
  .factory('WebchatFactory', WebchatService.WebchatFactory)
  .factory('GmbFactory', GmbService.GmbFactory)
  .factory('GbmFactory', GbmService.GbmFactory)
  .factory('WhatsappFactory', WhatsappService.WhatsappFactory)
  .factory('BusinessChatFactory', BusinessChatService.BusinessChatFactory)
  .factory('TrustpilotFactory', TrustpilotService.TrustpilotFactory)
  .factory('LineFactory', LineService.LineFactory)
  .factory('KakaotalkFactory', KakaotalkService.KakaotalkFactory)
  .factory('LinkedinFactory', LinkedinService.LinkedinFactory)
  .factory('TiktokFactory', TiktokService.TiktokFactory);
